// Field configuration for different service types
export const FIELD_CONFIG = [
  {
    key: "contraIndications",
    title: "Contraindications",
    placeholder:
      "e.g., allergies, pregnancy, skin problems, specific health conditions, etc.",
    serviceTypes: [
      "Longevity treatments",
      "IV Therapy",
      "Pharmaceuticals",
      "Pharmaceuticals IV",
      "Supplements",
      "Medical procedures",
    ],
  },
  {
    key: "interactions",
    title: "Interactions",
    placeholder:
      "e.g., any possible interactions with other pharmaceuticals or supplements",
    serviceTypes: [
      "IV Therapy",
      "Pharmaceuticals",
      "Pharmaceuticals IV",
      "Supplements",
    ],
  },
  {
    key: "sideEffects",
    title: "Side effects",
    placeholder: "e.g., nausea, vomiting, headache, allergic reactions, etc.",
    serviceTypes: ["Pharmaceuticals", "Pharmaceuticals IV", "Supplements"],
  },
  {
    key: "specialInstructions",
    title: "Special instructions",
    placeholder:
      "e.g., any preparation instructions before the treatment or any aftercare instructions",
    serviceTypes: [
      "Longevity treatments",
      "IV Therapy",
      "Pharmaceuticals",
      "Pharmaceuticals IV",
      "Supplements",
      "Lab work",
      "Medical procedures",
    ],
  },
  {
    key: "preparation",
    title: "Preparation Requirements",
    placeholder:
      "e.g., fasting, abstinence from alcohol, caffeine, smoking, and/or exercise",
    serviceTypes: [
      "Longevity treatments",
      "IV Therapy",
      "Pharmaceuticals",
      "Pharmaceuticals IV",
      "Lab work",
      "Medical procedures",
    ],
  },
  {
    key: "treatmentGoal",
    title: "Treatment goal",
    placeholder:
      "e.g., chronic condition management, injury, pain relief, overall wellness, etc.",
    serviceTypes: [
      "Longevity treatments",
      "IV Therapy",
      "Pharmaceuticals",
      "Pharmaceuticals IV",
    ],
  },
  {
    key: "partner",
    title: "Testing Partner",
    placeholder: "",
    serviceTypes: ["Lab work", "Medical procedures"],
  },
  {
    key: "purpose",
    title: "Testing Purpose",
    placeholder:
      "e.g., illness diagnosis, existing conditions monitoring, treatment effectiveness assessment, routine check-up, etc.",
    serviceTypes: ["Lab work", "Medical procedures"],
  },
  {
    key: "purpose",
    title: "Consumption Purpose",
    placeholder:
      "e.g., energy boost, sleep improvement, nutrient deficiencies restoration, etc.",
    serviceTypes: ["Supplements"],
  },
  {
    key: "supplier",
    title: "Supplier/Manufacturer",
    placeholder: "",
    serviceTypes: ["Pharmaceuticals", "Pharmaceuticals IV", "Supplements"],
  },
  {
    key: "regulatoryDetails",
    title: "Regulatory Details",
    placeholder: null,
    type: "list" as const,
    options: [
      "Prescription Required",
      "Over-the-Counter",
      "Controlled Substance Pharmaceutical",
    ],
    serviceTypes: ["Pharmaceuticals", "Pharmaceuticals IV"],
  },
];
